import React, { PropsWithChildren } from "react";
import styles from "./Column.module.scss";
import classnames from "classnames";

type Grow = "2" | "4" | "6" | "8" | "10" | "12";

interface ColumnProps {
  grow: Grow;
}

export const Column: React.FC<ColumnProps & PropsWithChildren> = ({
  children,
  grow,
}) => {
  const cx = classnames.bind(styles);
  const getColumn = (size: Grow) => {
    switch (size) {
      case "2":
        return (
          <div className={cx(styles.Column, styles.grow_2)}>{children}</div>
        );
      case "4":
      default:
        return (
          <div className={cx(styles.Column, styles.grow_4)}>{children}</div>
        );
      case "6":
        return (
          <div className={cx(styles.Column, styles.grow_6)}>{children}</div>
        );
      case "8":
        return (
          <div className={cx(styles.Column, styles.grow_8)}>{children}</div>
        );
      case "12":
        return (
          <div className={cx(styles.Column, styles.grow_12)}>{children}</div>
        );
    }
  };

  return <>{getColumn(grow)}</>;
};
